import React from 'react';
import { useAuth } from '../context/AuthContext';
import Dashboard from '../pages/Dashboard';
import EmployeeDashboard from '../pages/EmployeeDashboard';
import CompanyDashboard from '../pages/CompanyDashboard';

function DashboardRouter() {
  const { user } = useAuth();

  // COMPANY_ADMIN sees consolidated cross-branch dashboard
  if (user?.role === 'COMPANY_ADMIN') {
    return <CompanyDashboard />;
  }

  // EMPLOYEE and SUPERVISOR see the employee dashboard
  const showEmployeeDashboard = user?.role === 'EMPLOYEE' || user?.role === 'SUPERVISOR';

  return showEmployeeDashboard ? <EmployeeDashboard /> : <Dashboard />;
}

export default DashboardRouter;
